/* storybook-check-ignore */
export default function ArrowIcon({
  color = '#082DE6',
  size = '16',
}: {
  color?: string;
  size?: number | string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <rect width="16" height="16" fill="white" />
        <path
          d="M13.9096 3.30435C14.0987 2.56772 13.4289 1.89793 12.6923 2.08707L3.342 4.48792C2.48976 4.70675 2.31517 5.84019 3.06206 6.30534L5.48291 7.81302L2.10248 11.1935C1.80959 11.4863 1.80959 11.9612 2.10248 12.2541L3.74066 13.8923C4.03355 14.1852 4.50842 14.1852 4.80132 13.8923L8.18218 10.5114L9.69129 12.9346C10.1564 13.6815 11.2899 13.5069 11.5087 12.6546L13.9096 3.30435Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
